import { Vector2, Vector3 } from "three";
import React from "react";
import ColorLib, { ColorInput } from "tinycolor2";
import _ from "underscore";
import { RunningProcessStatus } from "avvir";

import type { CanvasFontStyle } from "./canvas_helper";
import type { DefaultComponentProps, OverridableTypeMap, OverrideProps, Vector2Like, Vector3Like } from "type_aliases";
import type { Node, TabNode } from "flexlayout-react";
import type { Process, RunningProcessWithId } from "../../models/domain/process";


export function isVector2(object: any): object is Vector2 {
  return !!(object as Vector2)?.isVector2;
}

export function isVector2Like(object: any): object is Vector2Like {
  return typeof (object as Vector2Like)?.x === "number" && typeof (object as Vector2Like)?.y === "number";
}

export function isVector2Array(array: any[]): array is Vector2[] {
  return Array.isArray(array) && _.every(array, isVector2);
}

export function isVector2LikeArray(array: any[]): array is Vector2Like[] {
  return Array.isArray(array) && _.every(array, isVector2Like);
}

export function isVector3(object: any): object is Vector3 {
  return !!(object as Vector3)?.isVector3;
}

export function isVector3Like(object: any): object is Vector3Like {
  return typeof (object as Vector3Like)?.x === "number" && typeof (object as Vector3Like)?.y === "number" && typeof (object as Vector3Like)?.z === "number";
}

export function isTabNode(node: Node): node is TabNode {
  return node.getType() === "tab";
}

export function isOverrideProps<M extends OverridableTypeMap, C extends React.ElementType>(props: DefaultComponentProps<M> | OverrideProps<M, C>): props is OverrideProps<M, C> {
  return !!(props as OverrideProps<M, C>)?.component;
}

export function isProcessWithId(process: Process): process is RunningProcessWithId {
  return (process as RunningProcessWithId).processId != null;
}

export function isCanvasFontStyle(object: any): object is CanvasFontStyle {
  return !!(object as CanvasFontStyle)?.name || !!(object as CanvasFontStyle)?.color || !!(object as CanvasFontStyle)?.size || !!(object as CanvasFontStyle)?.weight;
}

export function isColorInput(object: any): object is ColorInput {
  return new ColorLib(object).isValid();
}

export function isRunningProcessStatus(status: any): status is RunningProcessStatus {
  return status === RunningProcessStatus.RUNNING
         || status === RunningProcessStatus.COMPLETED
         || status === RunningProcessStatus.FAILED;
}
